// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"de7b8212","237":"ad031fcc","389":"fb7d19db","494":"6d419361","531":"c4d9945c","795":"0c01f6d8"}[chunkId] + ".chunk.js";
};